import { useResourceRootContext } from "@/layouts/ResourceContext";
import { forwardRef } from "react";
import { Link as ReactLink } from 'react-router-dom';

export const Link = forwardRef(function BaseLink(props, ref) {
  const { to, ...rest } = props;
  const { state } = useResourceRootContext();
  if (state.tenantName) {
    return <ReactLink to={`/t/${state.tenantName}${to}`} {...rest} ref={ref} />;
  }
  return <ReactLink to={to} {...props} ref={ref} />;
});